import React, { Fragment, ReactNode, useEffect, useRef, useState } from 'react';
import Show from '../Show/Show';
import { Dimensions, FlatList, View } from 'react-native';

// Vertical room the drop shadow needs below a card before the list clips it.
const SHADOW_BLEED = 24;
import { Dots } from './Dots';
import { SPACING } from '../../config/designSystem/Spacing';
import { isWeb } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useIsSmallWeb } from '../../hooks/ui/useIsSmallWeb';


interface SwipingListItem {
    child: (height: number) => ReactNode,
    show: boolean,
}

interface SwipingListProps  {
    elements: SwipingListItem[],
    marginHorizontal?: number
}

export const SwipingList = ({elements, marginHorizontal = 0}: SwipingListProps) => {

  const flatListRef = useRef<FlatList>(null);
  const [indexSelected, setIndexSelected] = useState(0);
  const [maxHeight, setMaxHeight] = useState<number>(0);
  const filteredElements = elements.filter(item => item.show);
  const nbItems = filteredElements.length;
  const {width} = useAvailableDimensions();
  const {isLargeEnoughForLateralBarWeb, isSmallWeb} = useIsSmallWeb();
  const WIDTH = isLargeEnoughForLateralBarWeb ? ((width)/nbItems - marginHorizontal) : width;


  useEffect(() => {
    if(isWeb) {
      const changeDimListener = Dimensions.addEventListener('change', () => {
        setMaxHeight(0);
      });

      return () => {
        changeDimListener.remove();
      };
    }
  }
  , []);



  if(nbItems === 0) {
    return null;
  }



  return (
    <View style={{rowGap: SPACING['sp-16']}}>
      <FlatList
        ref={flatListRef}
        data={elements}
        // Room for the card's drop shadow.
        //
        // Each row is pinned to the measured CARD height (see `height: maxHeight`
        // below, which equalises the cards in the carousel), and a drop shadow paints
        // OUTSIDE that box. The FlatList is therefore exactly as tall as the card and
        // clips the shadow dead flat along the bottom edge. Padding the content gives
        // the shadow somewhere to land without disturbing the row-height equalisation.
        contentContainerStyle={{paddingBottom: SHADOW_BLEED}}
        horizontal={!isSmallWeb}
        scrollEnabled={nbItems>1 && !isWeb}

        snapToInterval={width}
        showsHorizontalScrollIndicator={false}
        onScroll={event => {
          const offsetX = event.nativeEvent.contentOffset.x;
          const newIndex = Math.round(offsetX / (width + marginHorizontal));
          setIndexSelected(newIndex);
        }}

        renderItem={({item, index}) => {
          let style = {};
          if(index < filteredElements.length - 1) {
            style = {marginRight: marginHorizontal};
          }
          if(index === 0) {
            style = {...style, marginLeft: marginHorizontal};
          }
          if(item.show) {
            return (
              <Fragment key={index}>
                <View style={[{width: WIDTH  }, !!maxHeight && {height: maxHeight}, isSmallWeb && {marginVertical: SPACING['sp-20'], minWidth: 250}]}
                  onLayout={event => {
                    const { height } = event.nativeEvent.layout;
                    if(!maxHeight || height>maxHeight) {
                      setMaxHeight(height);
                    }}}>
                  <View style={[ {marginHorizontal},
                  ]}
                  >
                    {item.child(maxHeight || undefined)}
                  </View>
                </View>
              </Fragment>
            );
          } else {
            return <></>;
          }
        }}



        keyExtractor={(item, index) => index.toString()}
      />
      <Show when={!isWeb}>
        <View style={{width, alignItems: 'center', justifyContent: 'center'}}>
          <Dots nbElements={nbItems} indexSelected={indexSelected}/>
        </View>
      </Show>
    </View>
  );
};

